import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noMatches: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedFetch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noMatches: {
		id: 'issue-field-assets.edit.no-matches',
		defaultMessage: 'No Matches',
		description: 'Select menu message. Shows there is no assets found',
	},
	failedFetch: {
		id: 'issue-field-assets.edit.failed-fetch',
		defaultMessage: 'Search failed. Please try again.',
		description: 'Message when fetching assets fails',
	},
});
export default messages;
